var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-cabinet-profile-personal"},[_c('ui-infolist',{attrs:{"info":_vm.info}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }